import React from 'react';
import {useAuth} from "../../../helpers/AuthContext";
import Form from "../../Form";
import CouponForm from "./CouponForm";

function EditCouponForm({
                            coupon,
                            onSuccess,
                            onError,
}) {
    const {fetch, API_URL} = useAuth();
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleSubmit = async (values) => {
        if (isSubmitting) return; // Prevent multiple submissions
        setIsSubmitting(true);
        console.log('Form submitted', values);
        try {
            const response = await fetch(API_URL + '/v1/seller/coupons/' + coupon.uuid, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values),
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            console.log('Coupon updated successfully:', json);
            if (onSuccess) {
                onSuccess(json);
            }
        } catch (error) {
            console.error('Error updating coupon:', error);
            if (onError) {
                onError(error);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleChange = async (values) => {
        console.log('Form values changed', values);
    };
    return (
        <CouponForm
            onSubmit={handleSubmit}
            onChange={handleChange}
            initialValues={coupon || {}}
            submitBtnText="Update Coupon"
        />
    )
}

export default EditCouponForm;
